import { APIError } from '../errors/APIError';
import { useAPIMutation, useAPIQuery } from '../useAPIProvider';

export const useExclusiveFilters = () => {
  return useAPIQuery(['getExclusiveFilters'], async client => {
    const response = await client.exclusiveFilters.getFilters();
    if (response.status !== 200) throw APIError.fromResponse(response);
    return response.body.items;
  });
};

export const useExclusiveFilter = (id: string) => {
  return useAPIQuery(['getExclusiveFilter', id], async client => {
    const response = await client.exclusiveFilters.getFilter({ params: { id } });
    if (response.status !== 200) throw APIError.fromResponse(response);
    return response.body;
  });
};

interface CreateExclusiveFilterArgs {
  daasCatalogItemId: string;
  partnerIds: string[];
  companyIds?: string[];
}

export const useCreateExclusiveFilters = () => {
  return useAPIMutation((client, query) => {
    return async ({ daasCatalogItemId, partnerIds, companyIds }: CreateExclusiveFilterArgs) => {
      const response = await client.exclusiveFilters.createFiltersForProduct({
        params: { id: daasCatalogItemId },
        body: {
          mspIds: partnerIds,
          customerIds: companyIds
        }
      });

      if (response.status !== 200) throw APIError.fromResponse(response);

      await query.invalidateQueries(['getExclusiveFilters']);
      await query.invalidateQueries(['getProducts']);
      return response.body;
    };
  });
};
